import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import othersSearchList from "@/js/components/others/_search-list.js";

// 物件種別トグル（戸建/土地）。両方チェックで type=all、片方のみで単一種別に絞り込む。
// 最後の1つはOFFにできない（最低どちらか一方は必ずON）。
// 対象要素: [data-type-toggle]
//   - data-fragment-href-template がある場合(エリアTOPページ埋め込み時): URLを変えずにエリア
//     チェックボックスツリーのみAjaxで差し替える(__TYPE__ を選択種別に置換)
//   - ない場合、または差し替えに失敗した場合: data-href-template の __TYPE__ を選択種別に置換して遷移
export const setTypeToggle = () => {
    const container = document.querySelector('[data-type-toggle]');
    if (!container) return;
    if (container.hasAttribute('data-type-toggle-initialized')) return;
    container.setAttribute('data-type-toggle-initialized', '');

    const hrefTemplate = container.dataset.hrefTemplate;
    const fragmentHrefTemplate = container.dataset.fragmentHrefTemplate;
    const buttons = Array.from(container.querySelectorAll('[data-type-value]'));

    buttons.forEach((button) => {
        button.addEventListener('click', async () => {
            const isChecked = button.hasAttribute('data-checked');
            const otherChecked = buttons.some((b) => b !== button && b.hasAttribute('data-checked'));
            if (isChecked && !otherChecked) return;

            button.toggleAttribute('data-checked');

            const checkedValues = buttons
                .filter((b) => b.hasAttribute('data-checked'))
                .map((b) => b.dataset.typeValue);
            const newType = checkedValues.length === buttons.length ? 'all' : checkedValues[0];

            if (fragmentHrefTemplate) {
                const swapped = await swapAreaSearchList(fragmentHrefTemplate.replace('__TYPE__', newType), newType);
                if (swapped) return;
            }
            window.location.href = hrefTemplate.replace('__TYPE__', newType);
        });
    });
};

// エリアチェックボックスツリー([data-pickup-search])をAjaxで取得したHTMLに差し替える。
// 差し替え後は検索フォームのtype隠しフィールドを同期し、アコーディオン/件数表示の初期化をやり直す。
// 成功時true、失敗時false(呼び出し側で従来のページ遷移にフォールバックする)
const swapAreaSearchList = async (url, newType) => {
    const target = document.querySelector('[data-pickup-search]');
    if (!target) return false;

    try {
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
        if (!response.ok) throw new Error(`Failed to load area search list: ${response.status}`);

        const data = await response.json();
        if (!data.html) throw new Error('Empty area search list response');

        target.outerHTML = data.html;

        const typeInput = document.querySelector('#search-form input[name="type"]');
        if (typeInput) typeInput.value = newType;

        othersSearchList();
        setCountAction();
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const setCountAction = () => {
    const countAction = new CountAction(document.querySelector('[data-pickup-search]'));
    countAction.on('countChange', (e) => {
        const target = document.querySelector('[data-pickup-count]');
        countUpAction(target, e.count);
        if (e.count == 0) {
            document.querySelector('.p-submit-result__target').dataset.empty = '';
            document.querySelectorAll('.c-others-search-submit .c-buttons-submit').forEach(button => button.setAttribute('disabled', ''));
        } else {
            delete document.querySelector('.p-submit-result__target').dataset.empty;
            document.querySelectorAll('.c-others-search-submit .c-buttons-submit').forEach(button => button.removeAttribute('disabled'));
        }
    });
}
